import { IDatasource } from "./IDatasource"

export class Datasource implements IDatasource {
    type="ai_datasource"
    version=0
    create_sql=""
    ready=false
    name="";
    prompt="";
    fields=[]
    obj:any
    table:any[]=[]
}

